import { useState } from 'react'
import { useDebounce } from 'react-use'

import { CircularProgress } from '../../shared/NarusMaterial'

import styles from './loading-indicator.module.css'

interface Props {
  loading: boolean
  spinner?: boolean
  delay?: number
  style?: React.CSSProperties
}

export function LoadingIndicator ({ loading, spinner = true, delay = 750, style = {} }: Props): JSX.Element | null {
  let [ showLoading, setShowLoading ] = useState(loading)

  useDebounce(() => {
    setShowLoading(loading)
  }, loading ? delay : 0, [ loading ])

  if (!showLoading) {
    return null
  }

  return (
    <div className={styles.wrapper} style={style}>
      {spinner && (
        <CircularProgress />
      )}
    </div>
  )
}
